angular.module('lf.desktop')

.controller('CheckoutLoginCtrl', function ($scope, authenticationService) {

  $scope.isUserLoggedIn = function () {
    return lf.data && lf.data.xhr && lf.data.xhr.user.emailAddress;
  }
  
  $scope.isGuest = function () {
    return lf.data.xhr.user.isGuest;
  }

  $scope.getUserEmail = function () {
    return lf.data.xhr.user.emailAddress;
  }
  
  $scope.form = {};
  
  $scope.loginGuest = login.bind(null, 'Guest');
  
  $scope.loginUser = login.bind(null, 'User');
  
  function login (type) {
    $scope.isRequesting = true;
    authenticationService['login' + type]($scope.form)
      .success(function (data) {
        if (data.success || (data.data && data.data.success)) {
          window.location.reload();
        } else {
          $scope.isRequesting = false;
        }
      });
  }
});
